import React from 'react'
import { getReportState } from '../../store/store';
import { getEleArray, getTagValue, getAttrValue } from 'helpers/Helpers';

export default function RiskScores({scores}) {

	return (
		<div className='w-full flex flex-col'>
			<div className='header-bar'>
				<div className='header-text'>Risk Scores</div>
			</div>
			<div className='w-full flex flex-col border-2'>
			{ scores &&
				scores.map((s, i) => {
					return (showRiskScore(s, i))
				})
			}
			{ !scores && 
					<div className='text-xl font-semibold pl-2'>NO RISK SCORES</div>
			}
			</div>
		</div>
	)
}

function showRiskScore(score, i) {
	//console.log("show score: ",score);
	var reportState = getReportState();
	//console.log("reportState: ",reportState);
	var ownerName = '';
	var ownerSSN = '';
	var owner = getAttrValue(score, "BorrowerID");
	//console.log("owner: ", owner);
	if (owner === 'PRIMARY_SUBJECT') {
		ownerName = reportState.SubjectName;
		ownerSSN = reportState.SubjectSSN;
	} else if (owner === 'SECONDARY_SUBJECT') {
		ownerName = reportState.SpouseName;	
		ownerSSN = reportState.SpouseSSN;
	}

	var factors = getEleArray( score, "_FACTOR");
	//console.log("factors: ", factors);
	//console.log(score.children);
	//console.log(score.getElementsByTagName("RiskScoreValue")[0].value);

	return (
			<div key={i} className='pb-4'>
				<div className="w-full flex px-2 flex-row courier">
					<div className="w-[8%] title">Score:</div>
					<div className="w-[7%] font-bold">{getAttrValue(score, "_Value")}</div>
					<div className="w-[10%] title pr-2">Repository:</div>
					<div className="w-[8%]">{getAttrValue(score, "CreditFileID")}</div>
					<div className=" title pr-2">Model:</div>
					<div className="">{getAttrValue(score, "_ModelNameType")}</div>
				</div>
				<div className="w-full flex px-2 flex-row justify-start text-start value">
					<div className="w-[15%] title">Borrower:</div>
					<div className="w-[35%] ">{ownerName}</div>
					<div className="w-[15%] title">Borrower SSN:</div>
					<div className="w-[35%]">{ownerSSN}</div>
				</div>
				<div className="w-full flex px-2 flex-row justify-start text-start">
					<div className="w-[15%] title">Factors:</div>
					<div className="w-[85%] flex flex-col">
					{factors && 
							factors.map((factor, i) => {
								//console.log("factor: ", factor);
								return (
									<div key={i} className="w-full flex flex-row value">
										<div className='w-[6%]'>{Number(getAttrValue(factor, "_Code"))}</div>
										<div className=''>{getAttrValue(factor, "_Text")}</div>
									</div>
								)
							})
					}
					</div>
				</div>
			</div>
	)	
}
